/** @format */

import React, { useState } from "react";
import loginbg from "images/Login.png";


import AuthHeader from "../components/auth-header";
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import "./styles.css"
import RegisterCard from "./RegisterCard";
import CheckEmailCard from "./CheckEmailCard";
import RegisterLanding from "./RegisterLanding";
function NewApply() {
  const [cardIndex, setCardIndex] = useState(0);
  const [mode, setMode] = useState(null);

  // Handler to go to next card
  const handleNext = (selectedMode) => {
    if (cardIndex === 0 && selectedMode) {
      setMode(selectedMode);
      setCardIndex(1);
    } else if (cardIndex === 1) {
      setCardIndex(2);
    }
  };

  const handleBack = () => {
    if (cardIndex > 0) setCardIndex(cardIndex - 1);
  };

  // Card list with props
  const cardList = [
    <RegisterLanding key="landing" onNext={handleNext} mode={mode} />,
    <RegisterCard key="register" mode={mode} onNext={handleNext} onBack={handleBack} />,
    <CheckEmailCard key="checkemail" />,
  ];

  return (
    <>
      <div
        className="login-main-page auth-page"
        style={{
          background: "url(" + loginbg + ")",
          backgroundSize: "contain",
        }}
      >
        <AuthHeader showButton={false} showLogin={true}/>
        <div className="login-wrapper w-100 mt-4">
          <div className="container h-100">
            <div className="row h-100 align-items-center justify-content-center">
              <TransitionGroup component={null}>
                <CSSTransition
                  key={cardIndex}
                  timeout={400}
                  classNames="fade-slide-right"
                >
                  <div style={{ width: '100%' }}>
                    {cardList[cardIndex]}
                  </div>
                </CSSTransition>
              </TransitionGroup>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewApply;